import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQuery } from './auth'

export const locationsApi = createApi({
  baseQuery: baseQuery(),
  reducerPath: 'locationsApi',
  endpoints: (builder) => ({
    getLocations: builder.query<LocationItem[], { q?: string, id?: string, loc_type?: string, hierarchy?: boolean, deps_id?: string, include_extra?: boolean }>({
      query: ({ q, id, loc_type, hierarchy, deps_id, include_extra }) => ({ url: 'dictionary/v4.0/search/locations/', params: { q, id, loc_type, hierarchy, deps_id, include_extra } }),
    }),
    getLocationById: builder.query<LocationItem, string>({
      query: (id) => ({ url: `dictionary/v4.0/locations/${id}/` }),
    }),
  }),
})

export const { useLazyGetLocationsQuery, useLazyGetLocationByIdQuery } = locationsApi
